// Mirrors the backend's multer fileFilter allow-list exactly
// (tutorslinks-backend/routes/userRoutes.js) — rejecting a bad file here
// means the user finds out immediately, instead of after a full upload
// round-trip only for the backend to reject it with an unhelpful error.
export const ALLOWED_FILE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/pdf",
  "video/mp4",
  "video/quicktime",
];

// iPhones default to HEIC/HEIF for camera photos — it matches a browser file
// picker's "image/*" filter, so it slips past the input's `accept` attribute,
// but the backend doesn't accept it. This is the single most common cause of
// "Profile Failed to Save": the user never finds out the file was rejected
// until after submitting the whole form.
const HEIC_TYPES = ["image/heic", "image/heif"];

/**
 * @param {File} file
 * @param {{ maxSizeBytes?: number, allowed?: string[] }} [opts]
 * @returns {string|null} an error message, or null if the file is valid
 */
export function validateFile(file, opts = {}) {
  const { maxSizeBytes = 10 * 1024 * 1024, allowed = ALLOWED_FILE_TYPES } = opts;

  if (!file) return null;

  if (HEIC_TYPES.includes(file.type) || /\.heic$|\.heif$/i.test(file.name)) {
    return "iPhone HEIC photos aren't supported — in your camera, switch Settings → Camera → Formats to \"Most Compatible\", or choose a JPG/PNG file instead.";
  }

  if (!allowed.includes(file.type)) {
    return "Unsupported file format — please use JPG, PNG, WEBP, or PDF.";
  }

  if (file.size > maxSizeBytes) {
    return `File is too large — must be under ${Math.round(maxSizeBytes / (1024 * 1024))}MB.`;
  }

  return null;
}
